import $api from "@/zapi-frontend/shared/api/axios";
import { TDocument } from "@/zapi-frontend/shared/hooks/useDocuments/types";
import { tryCatch } from "@/zapi-frontend/shared/lib/tryCatch";
import { getMalwareScanMessage } from "@/zapi-frontend/shared/lib/malwareScanError";

export type TVaultFile = Pick<TDocument, "id" | "fileName" | "webUrl">;

export type TDownloadOutcome = { done: true } | { done: false; message: string | null };

// Saves one Vault document under its own name, or opens it in a new tab when it is a web link.
// Resolves to not done when the file could not be fetched or the browser blocked the tab; message is set
// when the malware scan withheld the file.
export async function downloadDocument(projectId: string, doc: TVaultFile): Promise<TDownloadOutcome> {
  if (doc.webUrl) return window.open(doc.webUrl, "_blank") ? { done: true } : { done: false, message: null };
  const [response, error] = await tryCatch(
    $api.get<{ data: { url: string } }>(`/projects/${projectId}/documents/${doc.id}`)
  );
  const url = response?.data.data.url;
  if (!url) return { done: false, message: getMalwareScanMessage(error) };
  const [blob] = await tryCatch(fetch(url).then((r) => r.blob()));
  if (!blob) return { done: false, message: null };
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = doc.fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(objectUrl);
  return { done: true };
}
